import React from 'react';
import { FieldValues, UseFormRegister } from 'react-hook-form';
import { ModalHeader } from '@/components/dashboard';
import { Button, Typography } from '@/components/common';
import { InputText } from '@/components/form';

export const END_OR_DELETE_CASE_MODAL_SHELL = {
	withXButton: true,
	backgroundColor: 'white' as const,
	classNameCardContainer: '!w-[560px] bg-white',
};

export const getEndOrDeleteCaseModalTitle = (hasClients: boolean): string =>
	hasClients ? 'End Case' : 'Delete Case';

interface EndOrDeleteCaseModalProps {
	hasClients: boolean;
	caseTitle: string;
	register: UseFormRegister<FieldValues>;
	onConfirm: (typedName: string) => void;
	onClose: () => void;
	isSubmitting: boolean;
}

export const EndOrDeleteCaseModal: React.FC<EndOrDeleteCaseModalProps> = ({
	hasClients,
	caseTitle,
	register,
	onConfirm,
	onClose,
	isSubmitting,
}) => {
	const [typedName, setTypedName] = React.useState('');
	const titleMatch = Boolean(caseTitle) && typedName === caseTitle;
	const confirmDisabled = isSubmitting || !titleMatch;

	return (
		<>
			<div className="text-left mb-2">
				<Typography type="regular-16">
					{hasClients
						? 'Ending this case will permanently deactivate it. All case data, documents, and client history will be preserved, but the case cannot be reopened or modified. This action cannot be undone.'
						: 'There are no clients on this case. It will be deleted immediately. No information will be preserved.'}
				</Typography>
				<Typography type="regular-16" className="break-after-all mt-6">
					Security Verification
				</Typography>
			</div>
			<InputText
				name="caseName"
				title="Enter the name of the case to confirm deletion:"
				classNameTitle="text-sm text-gray-35"
				register={register}
				placeholder={caseTitle}
				disabled={isSubmitting}
				onChangeCustom={(e) => {
					setTypedName((e.target as HTMLInputElement).value);
				}}
			/>
			<div className="flex justify-between items-center mt-8 gap-2">
				<Button
					type="button"
					decoration="secondary"
					size="fit"
					className="!h-12"
					disabled={isSubmitting}
					onClick={onClose}
				>
					Close
				</Button>
				<Button
					type="button"
					decoration="danger"
					size="fit"
					className="!h-12"
					disabled={confirmDisabled}
					onClick={() => onConfirm(typedName)}
				>
					{hasClients ? 'Confirm' : 'Confirm Delete'}
				</Button>
			</div>
		</>
	);
};

export const EndOrDeleteCaseModalTitle: React.FC<{ hasClients: boolean }> = ({
	hasClients,
}) => <ModalHeader title={getEndOrDeleteCaseModalTitle(hasClients)} />;
